import React from 'react'
import styles from '../AdminPanelPage.module.scss'
import BaseSearchSelect from './BaseSearchSelect'
import DriverInfoCard from '../../../components/DriverInfoCard/DriverInfoCard'

const DriversList = ({ tb, drivers = [], driversFilter = '', setDriversFilter = () => {},openCreateModal, loadDriversByTopBasePage = () => {}, employees = [], editingDriverByTopBase, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, driversPagination = {}, expandedDriverByTopBase = {}, toggleDriver = () => {}, printDriverPass = () => {}, downloadDriverPass = () => {}, topBases = [], chpps = [], privatePoints = [] }) => {
  // Ensure drivers is always an array
  const safeDrivers = Array.isArray(drivers) ? drivers : []
  
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong>Водители этой ТОП-базы</strong>
        <div>
          <button className={styles.smallBtn} onClick={() => openCreateModal('driver', { top_base: tb.id, top_base_name: tb.name })}>Добавить водителя</button>
        </div>
      </div>
      <div style={{ marginTop: 8 }}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder="Поиск..." value={driversFilter || ''} onChange={(e) => setDriversFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadDriversByTopBasePage(tb.id, 1, driversFilter || '') }} />

        </div>
        {(safeDrivers && safeDrivers.length) ? (
          <>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>Сотрудник</th>
                  <th>Телефон</th>
                  <th>Дополнительный ном.тел.</th>
                  <th>Номер машины</th>
                  <th>Модель машины</th>
                  <th>UID</th>
                  <th>QR string</th>
                  <th>Фото</th>
                  <th>QR (изображение)</th>
                  <th>Создано</th>
                  <th>Статус</th>
                  <th>Статус машины</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                {safeDrivers.map((d, index) => (
                  <React.Fragment key={d.id}>
                    <tr onClick={(e) => { if (e.target && (e.target.tagName === 'BUTTON' || e.target.tagName === 'A' || e.target.tagName === 'INPUT' || e.target.tagName === 'IMG' || e.target.closest && e.target.closest('button')) ) return; toggleDriver(tb.id, d.id) }} style={{ cursor: 'pointer' }}>
                      <td>{index + 1}</td>
                      <td>{d.employee_name || d.employee}</td>
                      <td>{d.employee_phone || '-'}</td>
                      <td>{d.phone || '-'}</td>
                      <td>{d.vehicle_number || '-'}</td>
                      <td>{d.vehicle_model || '-'}</td>
                      <td>
                        {d.uid ? (
                          <button className={styles.uidBtn} onClick={(ev) => {
                            ev.stopPropagation();
                            try {
                              if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                                navigator.clipboard.writeText(d.uid)
                              } else {
                                const ta = document.createElement('textarea')
                                ta.value = d.uid
                                document.body.appendChild(ta)
                                ta.select()
                                document.execCommand('copy')
                                ta.remove()
                              }
                            } catch (e) {
                              // ignore
                            }
                          }}>{d.uid}</button>
                        ) : '-'}
                      </td>
                      <td>{d.qrcode_scr || '-'}</td>
                      <td>
                        {d.photo ? (
                          <img className={styles.thumb} src={(d.photo && d.photo.url) ? d.photo.url : d.photo} alt={`photo-${d.id}`} />
                        ) : '-'}
                      </td>
                      <td>
                        {d.qrcode_img ? (
                          <img className={styles.thumb} style={{ cursor: 'pointer' }} onClick={(ev) => { ev.stopPropagation(); downloadDriverPass(d, 'ТОПЛИВНАЯ БАЗА', topBases.find(x => String(x.id) === String(d.top_base))?.name || '') }} src={(d.qrcode_img && d.qrcode_img.url) ? d.qrcode_img.url : d.qrcode_img} alt={`qrcode-${d.id}`} />
                        ) : '-'}
                      </td>
                      <td>{d.created_at}</td>
                      <td>{d.is_active ? 'Активен' : 'Неактивен'}</td>
                      <td>{d.status_display}</td>
                      
                      
                      <td>
                        <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); startEdit('driver', { topBase: tb.id, drId: d.id }, { employee: d.employee, top_base: d.top_base || tb.id, vehicle_number: d.vehicle_number, vehicle_model: d.vehicle_model, phone: d.phone, is_active: d.is_active }) }}>Изменить</button>
                      </td>
                    </tr>
                    {expandedDriverByTopBase[tb.id] === d.id && (
                      <tr>
                        <td colSpan={14} style={{ textAlign: 'start', padding: 12 }}>
                          <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 16 }}>
                              <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); printDriverPass(d, 'ТОПЛИВНАЯ БАЗА', topBases.find(x => String(x.id) === String(d.top_base))?.name || '') }}>Печать</button>
                            </div>
                            <DriverInfoCard driver={d} />
                          </div>
                        </td>
                      </tr>
                    )}
                    {editingDriverByTopBase[tb.id] === d.id && (
                      <tr>
                        <td colSpan={14}>
                          <div style={{ padding: 8 }}>
                            <label>Сотрудник</label>
                            <div style={{ display: 'inline-block', minWidth: 220 }}>
                              <input placeholder="Поиск сотрудника..." value={''} onChange={() => {}} />
                              <select value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).employee || ''} onChange={(e) => { setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], employee: Number(e.target.value) } })); }}>
                                <option value="">— Выберите сотрудника —</option>
                                {employees.map(emp => (<option key={emp.id} value={emp.id}>{emp.label}</option>))}
                              </select>
                            </div>
                            <label style={{ marginLeft: 8 }}>Тип базы</label>
                            <select 
                              value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point')} 
                              onChange={(e) => { 
                                const baseType = e.target.value;
                                setEditPayloads(p => ({ 
                                  ...p, 
                                  [`driver_${tb.id}_${d.id}`]: { 
                                    ...p[`driver_${tb.id}_${d.id}`], 
                                    base_type: baseType,
                                    top_base: baseType === 'top_base' ? (p[`driver_${tb.id}_${d.id}`]?.top_base || null) : null,
                                    chpp: baseType === 'chpp' ? (p[`driver_${tb.id}_${d.id}`]?.chpp || null) : null,
                                    private_point: baseType === 'private_point' ? (p[`driver_${tb.id}_${d.id}`]?.private_point || null) : null
                                  } 
                                })); 
                              }}
                              style={{ marginLeft: 8 }}
                            >
                              <option value="top_base">ТОП-База</option>
                              <option value="chpp">ТЭЦ</option>
                              <option value="private_point">Соц.объект/МСУ</option>
                            </select>
                            <label style={{ marginLeft: 8 }}>
                              {(editPayloads[`driver_${tb.id}_${d.id}`] || {}).base_type === 'chpp' ? 'ТЭЦ' : 
                               (editPayloads[`driver_${tb.id}_${d.id}`] || {}).base_type === 'private_point' ? 'Соц.объект/МСУ' : 'ТОП-База'}
                            </label>
                            <BaseSearchSelect
                              baseType={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point')}
                              value={
                                (editPayloads[`driver_${tb.id}_${d.id}`] || {}).base_type === 'chpp' ? 
                                  ((editPayloads[`driver_${tb.id}_${d.id}`] || {}).chpp || d.chpp || '') : 
                                (editPayloads[`driver_${tb.id}_${d.id}`] || {}).base_type === 'private_point' ? 
                                  ((editPayloads[`driver_${tb.id}_${d.id}`] || {}).private_point || d.private_point || '') : 
                                  ((editPayloads[`driver_${tb.id}_${d.id}`] || {}).top_base || d.top_base || tb.id)
                              }
                              onChange={(baseId) => {
                                const baseType = (editPayloads[`driver_${tb.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point');
                                setEditPayloads(p => ({ 
                                  ...p, 
                                  [`driver_${tb.id}_${d.id}`]: { 
                                    ...p[`driver_${tb.id}_${d.id}`], 
                                    [baseType]: baseId
                                  } 
                                }));
                              }}
                              placeholder="Поиск базы..."
                              style={{ marginLeft: 8 }}
                            />
                            <label style={{ marginLeft: 8 }}>Номер машины</label>
                            <input value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).vehicle_number || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], vehicle_number: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>Модель</label>
                            <input value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).vehicle_model || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], vehicle_model: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>Телефон</label>
                            <input value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], phone: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>Активен</label>
                            <input type="checkbox" checked={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], is_active: e.target.checked } }))} />
                            
                            {/* Загрузка новых документов */}
                            <div style={{ marginTop: 16, borderTop: '1px solid #e0e0e0', paddingTop: 12 }}>
                              <label>Добавить документы:</label>
                              <input 
                                type="file" 
                                multiple 
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                                onChange={(e) => {
                                  setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], newDocuments: Array.from(e.target.files || []) } }))
                                }}
                                style={{ marginTop: 4 }}
                              />
                              {((editPayloads[`driver_${tb.id}_${d.id}`] || {}).newDocuments || []).length > 0 && (
                                <div style={{ marginTop: 8, fontSize: '13px', color: '#666' }}>
                                  Выбрано: {(editPayloads[`driver_${tb.id}_${d.id}`] || {}).newDocuments.length} файл(ов)
                                </div>
                              )}
                            </div>

                            <div style={{ marginTop: 8 }}>
                              <button className={styles.btn_pin} onClick={() => saveEdit('driver', { topBase: tb.id, drId: d.id })}>Сохранить</button>
                              <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('driver', { topBase: tb.id })}>Отмена</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            {(driversPagination && driversPagination.count > 0) && (
              <div className={styles.pagination}>
                <button disabled={!driversPagination.previous} onClick={() => loadDriversByTopBasePage(tb.id, (driversPagination.page || 1) - 1, driversFilter)}>Пред.</button>
                <span>Стр. {driversPagination.page || 1} из {Math.ceil(driversPagination.count / 25)} — Всего: {driversPagination.count}</span>
                <button disabled={!driversPagination.next} onClick={() => loadDriversByTopBasePage(tb.id, (driversPagination.page || 1) + 1, driversFilter)}>След.</button>
              </div>
            )}
          </>
        ) : (
          <div>Нет водителей для этой ТОП-базы</div>
        )}
      </div>
    </div>
  )
}

export default DriversList
